import { DollarSign, Check, Undo2 } from 'lucide-react'
import { useSettlements, useMarkSettled, useMarkUnsettled } from '../hooks/useSettlements'

export default function Settlements() {
  const { data: settlements, isLoading } = useSettlements()
  const markSettled = useMarkSettled()
  const markUnsettled = useMarkUnsettled()

  const unsettled = settlements?.filter((s) => !s.settled) || []
  const settled = settlements?.filter((s) => s.settled) || []

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem' }}>
        Settle Up
      </h1>

      {isLoading ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem' }}>Loading...</p>
      ) : !settlements?.length ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '40vh',
          gap: '1rem',
          textAlign: 'center',
          color: 'var(--text-muted)',
        }}>
          <DollarSign size={48} />
          <p style={{ fontSize: '0.875rem' }}>No settlements yet — play some games first!</p>
        </div>
      ) : (
        <>
          {/* Outstanding */}
          {unsettled.length > 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h2 style={{ fontSize: '0.75rem', fontWeight: '600', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>
                Outstanding
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {unsettled.map((s) => (
                  <div
                    key={s.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.875rem 1rem',
                      backgroundColor: 'var(--bg-secondary)',
                      borderRadius: '0.5rem',
                      border: '1px solid var(--border-color)',
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: '500', fontSize: '0.9375rem', marginBottom: '0.125rem' }}>
                        <span style={{ color: 'var(--accent-danger)' }}>{s.payer?.display_name}</span>
                        {' '}owes{' '}
                        <span style={{ color: 'var(--accent-primary)' }}>{s.payee?.display_name}</span>
                      </div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>
                        {s.game?.game_name || s.game?.course_name || 'Game'} &middot; {new Date(s.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    <span style={{ fontWeight: '700', fontSize: '1rem', color: 'var(--accent-warning)', flexShrink: 0 }}>
                      ${s.amount.toFixed(2)}
                    </span>
                    <button
                      onClick={() => markSettled.mutate(s.id)}
                      style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '9999px',
                        backgroundColor: 'var(--bg-tertiary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--accent-primary)',
                        flexShrink: 0,
                      }}
                    >
                      <Check size={20} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Settled */}
          {settled.length > 0 && (
            <div>
              <h2 style={{ fontSize: '0.75rem', fontWeight: '600', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>
                Settled
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {settled.map((s) => (
                  <div
                    key={s.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.875rem 1rem',
                      backgroundColor: 'var(--bg-secondary)',
                      borderRadius: '0.5rem',
                      border: '1px solid var(--border-color)',
                      opacity: 0.6,
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: '500', fontSize: '0.9375rem', textDecoration: 'line-through', marginBottom: '0.125rem' }}>
                        {s.payer?.display_name} → {s.payee?.display_name}
                      </div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>
                        Settled {s.settled_at ? new Date(s.settled_at).toLocaleDateString() : ''}
                      </div>
                    </div>
                    <span style={{ fontWeight: '600', fontSize: '0.875rem', color: 'var(--text-muted)', flexShrink: 0 }}>
                      ${s.amount.toFixed(2)}
                    </span>
                    <button
                      onClick={() => markUnsettled.mutate(s.id)}
                      style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '9999px',
                        backgroundColor: 'var(--bg-tertiary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--text-muted)',
                        flexShrink: 0,
                      }}
                    >
                      <Undo2 size={18} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}
